var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectLanguage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8455 11.1095C13.9463 11.4165 13.3164 9.90794 13.3164 9.90794C14.3358 8.86409 14.9469 7.54276 14.9469 6.10455C14.9469 2.73312 11.6008 0 7.47343 0C3.34607 0 0 2.73312 0 6.10455C0 9.47597 3.34607 12.2091 7.47343 12.2091C8.99953 12.2091 10.4172 11.8351 11.5998 11.1937C11.5998 11.1937 14.0598 13.0844 16.8455 11.1095Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99982 7.27247L4.40849 3L6.00293 7.27247",
    stroke: "#FF6B00",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47931 5.8175H5.42978",
    stroke: "#FF6B00",
    strokeWidth: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72101 6.20447H11.6994",
    stroke: "#FF6B00",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9563 6.21997C10.7427 7.15631 9.80594 9.15449 7.7674 9.65652",
    stroke: "#FF6B00",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64044 6.20444V5.19824",
    stroke: "#FF6B00",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34015 7.36548C8.78907 8.03628 9.96245 9.44908 11.0646 9.73391",
    stroke: "#FF6B00",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectLanguage);
export default __webpack_public_path__ + "static/media/select_language.ca6a352cd333a833b785a96a9dfefc73.svg";
export { ForwardRef as ReactComponent };